module.exports = __webpack_public_path__ + "media/forum/forum_icon-294255dc.svg";